import { FormInitializerReturnType, stringSchema } from 'src/Configuration/validation'
import { ManufacturerConnectionTerms } from '../components/manufacturer-list/ManufacturerConnectionTermsDialog'
import { boolean, object, string } from 'yup'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const MIN_VIN_LENGTH = 10

/**
 *  Initializes the form for accepting manufacturer connection terms
 * @param vinNeeded boolean
 * @returns initialValues and validationSchema for manufacturer connection terms form
 */
export const useManufacturerConnectionTermsFormInitializer = (
  vinNeeded: boolean
): FormInitializerReturnType<ManufacturerConnectionTerms, ManufacturerConnectionTerms> => {
  const { t } = useCustomTranslation()
  const stringSchemaWithTranslation = stringSchema(t)
  const initialValues = { vin: '', accepted: false }

  const vinSchema = stringSchemaWithTranslation({ minLength: MIN_VIN_LENGTH }).required()

  const validationSchema = object().shape({
    vin: string().concat(vinNeeded ? vinSchema : string()),
    accepted: boolean().required(),
  })

  return { initialValues, validationSchema }
}
